import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "@/components/Layout";
import Landing from "@/pages/Landing";
import Calculator from "@/pages/Calculator";
import History from "@/pages/History";
import Checklist from "@/pages/Checklist";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminSegnalatori from "@/pages/AdminSegnalatori";
import AdminChatStats from "@/pages/AdminChatStats";
import ClientLogin from "@/pages/ClientLogin";
import ClientRegister from "@/pages/ClientRegister";
import ClientDashboard from "@/pages/ClientDashboard";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Contattaci from "@/pages/Contattaci";
import Privacy from "@/pages/Privacy";
import CookieBanner from "@/components/CookieBanner";
import { AuthProvider } from "@/lib/auth";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Layout>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/calcolatore" element={<Calculator />} />
              <Route path="/storico" element={<History />} />
              <Route path="/checklist/:dossierId" element={<Checklist />} />
              <Route path="/login" element={<ClientLogin />} />
              <Route path="/registrati" element={<ClientRegister />} />
              <Route path="/area-cliente" element={<ClientDashboard />} />
              <Route path="/password-dimenticata" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/contattaci" element={<Contattaci />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/segnalatori" element={<AdminSegnalatori />} />
              <Route path="/admin/chat-stats" element={<AdminChatStats />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Layout>
          <Toaster richColors position="top-right" />
          <CookieBanner />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
